// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host(.aulani) {
  /* WDW COLOR CODE */
  /* AULANI COLOR CODE */
  /**
   * variables.scss
   * Contains the sitewide variables
   */
  /**
   * Breakpoints variables
   */
  /**
   * Colors variables
   */
  /**
   * z-index variables
   */
  /**
   * function.scss
   * Contains the sitewide functions
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * global.scss
   * Contains the sitewide global styles
   */
  /**
   * reset.scss
   * Contains the sitewide css reset
   */
}
:host(.aulani) * {
  background-repeat: no-repeat;
  box-sizing: border-box;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  position: relative;
  text-rendering: optimizeLegibility;
}
:host(.aulani) *:before, :host(.aulani) *:after {
  box-sizing: border-box;
}
:host(.aulani) *:focus {
  outline: 1px dotted #000;
}
:host(.aulani) html,
:host(.aulani) body {
  margin: 0;
  min-height: 100vh;
}
:host(.aulani) body {
  width: 100%;
}
:host(.aulani) img {
  width: 100%;
}
:host(.aulani) h1,
:host(.aulani) h2,
:host(.aulani) h3,
:host(.aulani) h4,
:host(.aulani) h5 {
  margin: 0;
}
:host(.aulani) h1,
:host(.aulani) h2,
:host(.aulani) h3,
:host(.aulani) h4,
:host(.aulani) h5,
:host(.aulani) h6,
:host(.aulani) span,
:host(.aulani) a,
:host(.aulani) li,
:host(.aulani) p,
:host(.aulani) input,
:host(.aulani) textarea {
  font-family: inherit;
}
:host(.aulani) .clearfix {
  zoom: 1;
}
:host(.aulani) .clearfix:after {
  clear: both;
}
:host(.aulani) .clearfix:after, :host(.aulani) .clearfix:before {
  content: " ";
  display: block;
  overflow: hidden;
  visibility: hidden;
  width: 0;
  height: 0;
}
:host(.aulani) .float-left {
  float: left;
}
:host(.aulani) .float-right {
  float: right;
}
:host(.aulani) html,
:host(.aulani) body,
:host(.aulani) div,
:host(.aulani) span,
:host(.aulani) object,
:host(.aulani) iframe,
:host(.aulani) h1,
:host(.aulani) h2,
:host(.aulani) h3,
:host(.aulani) h4,
:host(.aulani) h5,
:host(.aulani) h6,
:host(.aulani) p,
:host(.aulani) blockquote,
:host(.aulani) pre,
:host(.aulani) abbr,
:host(.aulani) address,
:host(.aulani) address,
:host(.aulani) cite,
:host(.aulani) code,
:host(.aulani) del,
:host(.aulani) dfn,
:host(.aulani) em,
:host(.aulani) img,
:host(.aulani) ins,
:host(.aulani) kbd,
:host(.aulani) q,
:host(.aulani) samp,
:host(.aulani) small,
:host(.aulani) strong,
:host(.aulani) sub,
:host(.aulani) sup,
:host(.aulani) var,
:host(.aulani) b,
:host(.aulani) i,
:host(.aulani) dl,
:host(.aulani) dt,
:host(.aulani) dd,
:host(.aulani) ol,
:host(.aulani) ul,
:host(.aulani) li,
:host(.aulani) fieldset,
:host(.aulani) form,
:host(.aulani) label,
:host(.aulani) legend,
:host(.aulani) table,
:host(.aulani) caption,
:host(.aulani) tbody,
:host(.aulani) tfoot,
:host(.aulani) thead,
:host(.aulani) tr,
:host(.aulani) th,
:host(.aulani) td,
:host(.aulani) article,
:host(.aulani) aside,
:host(.aulani) canvas,
:host(.aulani) details,
:host(.aulani) figcaption,
:host(.aulani) figure,
:host(.aulani) footer,
:host(.aulani) header,
:host(.aulani) hgroup,
:host(.aulani) menu,
:host(.aulani) nav,
:host(.aulani) section,
:host(.aulani) summary,
:host(.aulani) time,
:host(.aulani) mark,
:host(.aulani) audio,
:host(.aulani) video {
  background: transparent;
  border: 0;
  font-size: 100%;
  margin: 0;
  outline: 0;
  padding: 0;
  vertical-align: baseline;
}
:host(.aulani) article,
:host(.aulani) aside,
:host(.aulani) details,
:host(.aulani) figcaption,
:host(.aulani) figure,
:host(.aulani) footer,
:host(.aulani) header,
:host(.aulani) hgroup,
:host(.aulani) img,
:host(.aulani) menu,
:host(.aulani) nav,
:host(.aulani) section {
  display: block;
}
:host(.aulani) ol,
:host(.aulani) ul {
  list-style: none;
}
:host(.aulani) blockquote,
:host(.aulani) q {
  quotes: none;
}
:host(.aulani) blockquote :before,
:host(.aulani) blockquote :after,
:host(.aulani) q :before,
:host(.aulani) q :after {
  content: none;
}
:host(.aulani) a {
  background: transparent;
  font-size: 100%;
  margin: 0;
  padding: 0;
  text-decoration: none;
  touch-action: manipulation;
  vertical-align: baseline;
}
:host(.aulani) table {
  border-collapse: collapse;
  border-spacing: 0;
}
:host(.aulani) hr {
  border: 0;
  display: block;
  height: 1px;
  margin: 1em 0;
  padding: 0;
}
:host(.aulani) input,
:host(.aulani) select {
  vertical-align: middle;
}
:host(.aulani) address {
  font-style: normal;
}
:host(.aulani) input::-ms-clear {
  display: none;
}
:host(.aulani) button {
  background: none;
  border: 0;
  padding: 0;
}
:host(.aulani) .aulani .room-ready-terms-and-conditions p a {
  font-weight: 600;
  color: #D04901;
}
:host(.aulani) .aulani .room-ready-terms-and-conditions.edit p a {
  color: #B73C00;
}
:host(.aulani) .olci-container {
  padding: 0;
  margin: 0 auto;
  width: 100%;
}
:host(.aulani) .page-layout {
  background: #FFF;
  min-height: 100vh;
  padding: 0 0 20px;
}
:host(.aulani) .aulani-logo {
  padding-top: 32px;
  padding-bottom: 9px;
  border-bottom: thin solid #918F8C;
}
:host(.aulani) .aulani-logo .logo-wrap {
  width: 100%;
  margin: 0 auto;
}
:host(.aulani) .aulani-logo .logo-img {
  width: 149px;
  height: 50px;
  margin: 0 auto;
}
:host(.aulani) .error-header {
  font-family: Goudy-Regular;
  color: #382613;
  font-size: 32px;
  line-height: 40px;
  font-weight: 400;
  letter-spacing: 0;
}
:host(.aulani) .page-content {
  height: 661px;
}
:host(.aulani) .page-content .aulani-header {
  font-family: Goudy-Regular;
  color: #382613;
  margin-top: 35px;
  margin-left: 20px;
  font-size: 32px;
  line-height: 40px;
  font-weight: 400;
  letter-spacing: 0;
}
:host(.aulani) .page-content .error-page {
  padding-top: 6px;
}
:host(.aulani) .page-content .error-page .image-goofy .goofy-img {
  width: 221px;
  height: 251px;
  margin-left: 37px;
}
:host(.aulani) .page-content .error-page .image-goofy .checkin-bell-img {
  width: 255px;
  height: 240px;
  margin-left: 37px;
}
:host(.aulani) .page-content .error-page .error-info {
  margin-top: 29px;
}
:host(.aulani) .page-content .error-page .error-info .sorry-text {
  margin-left: 21px;
  font-family: "InspireTWDCMedium";
  font-size: 40px;
  color: #5C4830;
  letter-spacing: 0;
  line-height: 40px;
  font-weight: 400;
}
:host(.aulani) .page-content .error-page .error-info .error-text {
  margin-top: 22px;
  margin-left: 20px;
  font-family: "InspireTWDCMedium";
  font-size: 14px;
  color: #5C4830;
  letter-spacing: 0;
  line-height: 21px;
}
:host(.aulani) .page-content .error-page .error-info .error-text .try-again-link {
  font-family: "InspireTWDCRoman";
  font-size: 14px;
  color: #D04901;
  letter-spacing: 0;
  line-height: 24px;
  cursor: pointer;
}
:host(.aulani) .page-content .horizontal-line {
  border-bottom: thin solid #D8D8D8;
  margin-top: 44px;
  margin-left: 8px;
  margin-right: 22px;
}
@media (min-width: 767px) {
  :host(.aulani) .olci-container {
    padding: 0 40px;
  }
  :host(.aulani) .aulani-logo .logo-wrap {
    padding: 0 40px;
  }
  :host(.aulani) .aulani-logo .logo-img {
    margin-left: 0;
    margin-right: auto;
  }
  :host(.aulani) .page-content {
    height: 760px;
  }
  :host(.aulani) .page-content .aulani-header {
    font-size: 40px;
    letter-spacing: 0;
    line-height: 50px;
    margin-left: 0;
  }
  :host(.aulani) .page-content .error-page {
    padding-top: 143px;
  }
  :host(.aulani) .page-content .error-page .image-goofy {
    float: left;
    padding-right: 53px;
  }
  :host(.aulani) .page-content .error-page .image-goofy .goofy-img {
    margin-left: 40%;
  }
  :host(.aulani) .page-content .error-page .image-goofy .checkin-bell-img {
    margin-left: 40%;
  }
  :host(.aulani) .page-content .error-page .error-info {
    margin-top: 0;
    padding-top: 40px;
  }
  :host(.aulani) .page-content .error-page .error-info .sorry-text,
  :host(.aulani) .page-content .error-page .error-info .error-text {
    margin-left: 50%;
  }
  :host(.aulani) .page-content .horizontal-line {
    margin-top: 270px;
    margin-bottom: 18px;
  }
  :host(.aulani) .aulani-header {
    font-size: 32px;
    line-height: 40px;
    font-weight: 400;
    letter-spacing: 0;
  }
  :host(.aulani) .error-header {
    font-size: 40px;
    line-height: 50px;
    font-weight: 400;
    letter-spacing: 0;
  }
  :host(.aulani) .horizontal-line {
    margin-bottom: 30px;
  }
}
@media (min-width: 1024px) {
  :host(.aulani) .olci-container {
    width: 970px;
    padding: 0 15px;
  }
  :host(.aulani) .aulani-logo .logo-wrap {
    padding: 0 15px;
    width: 970px;
  }
  :host(.aulani) .page-content .error-page .image-goofy .goofy-img {
    margin-left: 199px;
  }
  :host(.aulani) .page-content .error-page .image-goofy .checkin-bell-img {
    margin-left: 199px;
  }
  :host(.aulani) .page-content .error-page .error-info .sorry-text,
  :host(.aulani) .page-content .error-page .error-info .error-text {
    margin-left: 0;
  }
}

:host(.wdw) {
  /* WDW COLOR CODE */
  /* AULANI COLOR CODE */
  /**
   * variables.scss
   * Contains the sitewide variables
   */
  /**
   * Breakpoints variables
   */
  /**
   * Colors variables
   */
  /**
   * z-index variables
   */
  /**
   * function.scss
   * Contains the sitewide functions
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * global.scss
   * Contains the sitewide global styles
   */
  /**
   * reset.scss
   * Contains the sitewide css reset
   */
}
:host(.wdw) * {
  background-repeat: no-repeat;
  box-sizing: border-box;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  position: relative;
  text-rendering: optimizeLegibility;
}
:host(.wdw) *:before, :host(.wdw) *:after {
  box-sizing: border-box;
}
:host(.wdw) *:focus {
  outline: 1px dotted #000;
}
:host(.wdw) html,
:host(.wdw) body {
  margin: 0;
  min-height: 100vh;
}
:host(.wdw) body {
  width: 100%;
}
:host(.wdw) img {
  width: 100%;
}
:host(.wdw) h1,
:host(.wdw) h2,
:host(.wdw) h3,
:host(.wdw) h4,
:host(.wdw) h5 {
  margin: 0;
}
:host(.wdw) h1,
:host(.wdw) h2,
:host(.wdw) h3,
:host(.wdw) h4,
:host(.wdw) h5,
:host(.wdw) h6,
:host(.wdw) span,
:host(.wdw) a,
:host(.wdw) li,
:host(.wdw) p,
:host(.wdw) input,
:host(.wdw) textarea {
  font-family: inherit;
}
:host(.wdw) .clearfix {
  zoom: 1;
}
:host(.wdw) .clearfix:after {
  clear: both;
}
:host(.wdw) .clearfix:after, :host(.wdw) .clearfix:before {
  content: " ";
  display: block;
  overflow: hidden;
  visibility: hidden;
  width: 0;
  height: 0;
}
:host(.wdw) .float-left {
  float: left;
}
:host(.wdw) .float-right {
  float: right;
}
:host(.wdw) html,
:host(.wdw) body,
:host(.wdw) div,
:host(.wdw) span,
:host(.wdw) object,
:host(.wdw) iframe,
:host(.wdw) h1,
:host(.wdw) h2,
:host(.wdw) h3,
:host(.wdw) h4,
:host(.wdw) h5,
:host(.wdw) h6,
:host(.wdw) p,
:host(.wdw) blockquote,
:host(.wdw) pre,
:host(.wdw) abbr,
:host(.wdw) address,
:host(.wdw) address,
:host(.wdw) cite,
:host(.wdw) code,
:host(.wdw) del,
:host(.wdw) dfn,
:host(.wdw) em,
:host(.wdw) img,
:host(.wdw) ins,
:host(.wdw) kbd,
:host(.wdw) q,
:host(.wdw) samp,
:host(.wdw) small,
:host(.wdw) strong,
:host(.wdw) sub,
:host(.wdw) sup,
:host(.wdw) var,
:host(.wdw) b,
:host(.wdw) i,
:host(.wdw) dl,
:host(.wdw) dt,
:host(.wdw) dd,
:host(.wdw) ol,
:host(.wdw) ul,
:host(.wdw) li,
:host(.wdw) fieldset,
:host(.wdw) form,
:host(.wdw) label,
:host(.wdw) legend,
:host(.wdw) table,
:host(.wdw) caption,
:host(.wdw) tbody,
:host(.wdw) tfoot,
:host(.wdw) thead,
:host(.wdw) tr,
:host(.wdw) th,
:host(.wdw) td,
:host(.wdw) article,
:host(.wdw) aside,
:host(.wdw) canvas,
:host(.wdw) details,
:host(.wdw) figcaption,
:host(.wdw) figure,
:host(.wdw) footer,
:host(.wdw) header,
:host(.wdw) hgroup,
:host(.wdw) menu,
:host(.wdw) nav,
:host(.wdw) section,
:host(.wdw) summary,
:host(.wdw) time,
:host(.wdw) mark,
:host(.wdw) audio,
:host(.wdw) video {
  background: transparent;
  border: 0;
  font-size: 100%;
  margin: 0;
  outline: 0;
  padding: 0;
  vertical-align: baseline;
}
:host(.wdw) article,
:host(.wdw) aside,
:host(.wdw) details,
:host(.wdw) figcaption,
:host(.wdw) figure,
:host(.wdw) footer,
:host(.wdw) header,
:host(.wdw) hgroup,
:host(.wdw) img,
:host(.wdw) menu,
:host(.wdw) nav,
:host(.wdw) section {
  display: block;
}
:host(.wdw) ol,
:host(.wdw) ul {
  list-style: none;
}
:host(.wdw) blockquote,
:host(.wdw) q {
  quotes: none;
}
:host(.wdw) blockquote :before,
:host(.wdw) blockquote :after,
:host(.wdw) q :before,
:host(.wdw) q :after {
  content: none;
}
:host(.wdw) a {
  background: transparent;
  font-size: 100%;
  margin: 0;
  padding: 0;
  text-decoration: none;
  touch-action: manipulation;
  vertical-align: baseline;
}
:host(.wdw) table {
  border-collapse: collapse;
  border-spacing: 0;
}
:host(.wdw) hr {
  border: 0;
  display: block;
  height: 1px;
  margin: 1em 0;
  padding: 0;
}
:host(.wdw) input,
:host(.wdw) select {
  vertical-align: middle;
}
:host(.wdw) address {
  font-style: normal;
}
:host(.wdw) input::-ms-clear {
  display: none;
}
:host(.wdw) button {
  background: none;
  border: 0;
  padding: 0;
}
:host(.wdw) .aulani .room-ready-terms-and-conditions p a {
  font-weight: 600;
  color: #D04901;
}
:host(.wdw) .aulani .room-ready-terms-and-conditions.edit p a {
  color: #B73C00;
}
:host(.wdw) .pepde {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAKuCAYAAABgwHabAAADZ0lEQVRIS83QZ08UURQG4NzfgaggKggSu9iCsaJYI2qkGLE3BIOKJbFEFBGjRkOv0kHq0kGaAtIEgkgHe++/YHzvYcc7M9ldAfnAlyenz91lxYO/JUYUDfxSUtj/U2J5/T+U6PhILm/o+kBOH7pEFiezF7WMHkSC9J7vEiPSur8h6sZIaifSlC4VybxGJL3AXMJf4ju+SoyI60BDQ/RzNIio9i8cjBAR7agJwto+SyysDTVlhDSkFWvBLegGtyC93ypzrwUNwd1nSO80Y05wu+mTxIhbzSCo6aNMI+aCODcb0AhsBDca0A2sV0E1IqD+g8Su12OOCKDoKRrENY5/HUb869DQQym4Wovulbp/crkWwxou8QPExRpTXKh5LzHi/JN3SpQ1HDj3GCPE2WrM+Q2BBnGmCg2/SkCRIU5Xo3GqCmuEb+VbZXqSp4RvBeYIURORT8UbiflU4ABxogIb3pWIvMt5VC7XvB4hVVCGNS/O8SEwp0euHSvFxuFSpEfK5IjSoyUyh0pe60coIg4a40DxK4npwYH9RRjWsK9YVdtbhA3Cs/ClMqLUswDDGvbkY3h3ARARpR6FnHyseeRjzZ3vuhcgdcsfVIM5N36FcM2jETmilNilw5qrDo2dOqSCHblomGY733XJHZDYtmxEhEsOrmzNQWSULdnYMMTmLKwZYhNvGGJjJk4RGzL69ThnItKDNedMzkMakdP1GUg1OPHaunSZtXzDKQ2nKBKsSUdtGKxO65PYqnROGg6sTMUaRSKlmoYVKdigGkXE8lQVjim9EjMM1hxTjLCMn9KShFNUW5qMyChLknokpiURa4uTVCxKxBWjLORfE12HBBx1SMABwQJ1Oj8eG4aY9wC7RrvUoBGjzOHduXyOoqE0To5mx3VLbJTMiu2SmCHseUMJvmYfS2galMrdmTF4yxhiG4PzhF20AF+ziwa2JpkRhbeMEptIfM001lEYUYIHWUcRoiFqcmQTiWh6JJ6mpJOnhKahSqfyLmF6jrpiWERWEXgaMU2NaIxoRLM2JRyXCUt+nrCKwFtEY0SRuGIRjj+HGO4ByzB8l7AIHwsmh+HHjDUT+VEN4huTQvF7/wdzfkAP/gPzUELUTEdGh+VTE0Lw+vGJWTB+2zh5Gr3FLBj/mhKqGWpo5oaV/gGNQYq8UD/CuwAAAABJRU5ErkJggg==) top center repeat-x;
  background-color: #1D96D7;
}
:host(.wdw) #backgroundGlowContainer {
  width: 100%;
  position: relative;
  margin: auto;
  max-width: 940px;
}
:host(.wdw) #backgroundGlow {
  width: 100%;
  height: 800px;
  position: absolute;
  top: -380px;
  z-index: -1;
  background: radial-gradient(ellipse at center, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.5) 50%, rgba(71, 218, 255, 0) 70%);
}
:host(.wdw) #pageContainer {
  background: transparent;
}
@media all and (max-width: 767px) {
  :host(.wdw) #backgroundGlow {
    top: -340px;
    height: 600px;
    background: radial-gradient(ellipse at center, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.4) 40%, rgba(255, 218, 255, 0) 70%);
  }
}
@media all and (max-width: 568px) {
  :host(.wdw) #backgroundGlow {
    top: -180px;
    height: 300px;
  }
}
:host(.wdw) .olci-container {
  padding: 0 10px;
  margin: 0 auto;
  width: 100%;
}
:host(.wdw) .page-layout {
  background: url('wdw-bg.6dc06ca158c4201a.png') top center repeat-x;
  min-height: 100vh;
  padding: 0 0 20px;
}
:host(.wdw) .page-content {
  background: #FFF;
  box-shadow: 0 0 4px 0 rgba(37, 59, 86, 0.5);
  border-radius: 12px;
  height: 100%;
}
:host(.wdw) .page-content .error-page {
  padding-top: 6px;
}
:host(.wdw) .page-content .error-page .image-goofy .goofy-img {
  width: 221px;
  height: 251px;
  margin-left: 37px;
}
:host(.wdw) .page-content .error-page .image-goofy .checkin-bell-img {
  width: 255px;
  height: 240px;
  margin-left: 37px;
}
:host(.wdw) .page-content .error-page .error-info {
  margin-top: 29px;
}
:host(.wdw) .page-content .error-page .error-info .sorry-text {
  margin-left: 21px;
  font-family: "InspireTWDCMedium";
  font-size: 40px;
  color: #253B56;
  letter-spacing: 0;
  line-height: 40px;
  font-weight: 400;
}
:host(.wdw) .page-content .error-page .error-info .error-text {
  margin-top: 22px;
  margin-left: 20px;
  font-family: "InspireTWDCMedium";
  font-size: 14px;
  color: #253B56;
  letter-spacing: 0;
  line-height: 21px;
}
:host(.wdw) .page-content .error-page .error-info .error-text .try-again-link {
  font-family: "InspireTWDCRoman";
  font-size: 14px;
  color: #1994D7;
  letter-spacing: 0;
  line-height: 24px;
  cursor: pointer;
}
:host(.wdw) .page-content .horizontal-line {
  background: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 14%, #DBDBDB 95%, #FBFBFB 100%);
  height: 1px;
  margin-top: 44px;
  margin-left: 8px;
  margin-right: 22px;
}
:host(.wdw) .page-content .footer-section {
  margin-left: 20px;
  margin-right: 20px;
}
:host(.wdw) .error-header h1 {
  color: #0470AB;
  font-family: "InspireTWDCRoman";
  font-size: 24px;
  line-height: 48px;
  font-weight: 400;
  letter-spacing: 0;
}
@media only screen and (min-width: 767px) {
  :host(.wdw) .olci-container {
    padding: 0 15px;
  }
  :host(.wdw) .page-content {
    padding: 40px 0;
  }
  :host(.wdw) .page-content .error-page {
    padding-top: 143px;
  }
  :host(.wdw) .page-content .error-page .image-goofy {
    float: left;
    padding-right: 53px;
  }
  :host(.wdw) .page-content .error-page .image-goofy .goofy-img {
    margin-left: 50%;
  }
  :host(.wdw) .page-content .error-page .image-goofy .checkin-bell-img {
    margin-left: 50%;
  }
  :host(.wdw) .page-content .error-page .error-info {
    padding-top: 40px;
  }
  :host(.wdw) .page-content .error-page .error-info .error-text {
    margin-left: 50%;
  }
  :host(.wdw) .page-content .error-page .error-info .sorry-text {
    margin-left: 50%;
  }
  :host(.wdw) .page-content .horizontal-line {
    margin-top: 270px;
    margin-bottom: 30px;
  }
  :host(.wdw) .page-content .footer-section {
    margin-left: 40px;
    margin-right: 40px;
  }
  :host(.wdw) .page-section {
    padding: 0 41px 30px 43px;
    border-bottom: 1px solid thin solid #D8D8D8;
  }
  :host(.wdw) .error-header h1 {
    padding: 29px 0 18px;
    font-size: 36px;
    line-height: 40px;
    font-weight: 400;
    letter-spacing: 0;
  }
}
@media (min-width: 1024px) {
  :host(.wdw) .olci-container {
    width: 970px;
  }
  :host(.wdw) .page-content {
    padding: 0;
    height: 760px;
  }
  :host(.wdw) .page-content .error-page .image-goofy .goofy-img {
    margin-left: 199px;
  }
  :host(.wdw) .page-content .error-page .image-goofy .checkin-bell-img {
    margin-left: 199px;
  }
  :host(.wdw) .page-content .error-page .error-info {
    padding-top: 40px;
  }
  :host(.wdw) .page-content .error-page .error-info .error-text {
    margin-left: 52px;
  }
  :host(.wdw) .page-content .error-page .error-info .sorry-text {
    margin-left: 21px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/error-banner/error-banner.component.scss","webpack://./src/assets/style/theme/index.scss","webpack://./src/assets/style/abstracts/variables.scss","webpack://./src/assets/style/abstracts/functions.scss","webpack://./src/assets/style/abstracts/mixins.scss","webpack://./src/assets/style/base/global.scss","webpack://./src/assets/style/base/reset.scss","webpack://./src/app/error-banner/error-banner.component.aulani.scss","webpack://./src/assets/style/base/font.scss","webpack://./src/assets/style/theme/background.scss","webpack://./src/app/error-banner/error-banner.component.wdw.scss"],"names":[],"mappings":"AAAA;ECAA,mBAAA;EAkBA,sBAAA;EClBA;;;IAAA;EAKA;;IAAA;EAgBA;;IAAA;EAQA;;IAAA;EC7BA;;;IAAA;ECAA;;;IAAA;EAAA;;;IAAA;ECEA;;;IAAA;ECFA;;;IAAA;ANoCA;AK7BA;EACI,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;EACA,kCAAA;AL+BJ;AK7BI;EAEI,sBAAA;AL8BR;AK3BI;EACI,wBAAA;AL6BR;AKzBA;;EAEI,SAAA;EACA,iBAAA;AL2BJ;AKxBA;EACI,WAAA;AL0BJ;AKvBA;EACI,WAAA;ALyBJ;AKtBA;;;;;EAKI,SAAA;ALwBJ;AKrBA;;;;;;;;;;;;EAYI,oBAAA;ALuBJ;AKpBA;EACI,OAAA;ALsBJ;AKpBI;EACI,WAAA;ALsBR;AKnBI;EAEI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;ALoBR;AKhBA;EACI,WAAA;ALkBJ;AKfA;EACI,YAAA;ALiBJ;AMjGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsEI,uBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;ANmGJ;AMhGA;;;;;;;;;;;;EAYI,cAAA;ANkGJ;AM/FA;;EAEI,gBAAA;ANiGJ;AM9FA;;EAEI,YAAA;ANgGJ;AM9FI;;;;EAEI,aAAA;ANkGR;AM9FA;EACI,uBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;ANgGJ;AM7FA;EACI,yBAAA;EACA,iBAAA;AN+FJ;AM5FA;EACI,SAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AN8FJ;AM3FA;;EAEI,sBAAA;AN6FJ;AM1FA;EACI,kBAAA;AN4FJ;AMxFI;EACI,aAAA;AN0FR;AMtFA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;ANwFJ;AMnFQ;EACI,gBAAA;EACA,cAAA;ANqFZ;AMjFY;EACI,cAAA;ANmFhB;AOtPA;EACI,UAAA;EACA,cAAA;EACA,WAAA;APwPJ;AOrPA;EACI,gBNRY;EMSZ,iBAAA;EACA,iBAAA;APuPJ;AOpPA;EACI,iBAAA;EACA,mBAAA;EACA,iCNGoB;ADmPxB;AOpPI;EACI,WAAA;EACA,cAAA;APsPR;AOnPI;EACI,YAAA;EACA,YAAA;EACA,cAAA;APqPR;AOjPA;EACI,0BAAA;EACA,cNPwB;EGNxB,eGec;EHdd,iBGcoB;EHbpB,gBAH+C;EAI/C,iBAJqE;AJqQzE;AOlPA;EACI,aAAA;APoPJ;AOlPI;EACI,0BAAA;EACA,cNjBoB;EMkBpB,gBAAA;EACA,iBAAA;EHzBJ,eG2BkB;EH1BlB,iBG0BwB;EHzBxB,gBAH+C;EAI/C,iBAJqE;AJkRzE;AOnPI;EACI,gBAAA;APqPR;AOlPY;EACI,YAAA;EACA,aAAA;EACA,iBAAA;APoPhB;AOlPY;EACI,YAAA;EACA,aAAA;EACA,iBAAA;APoPhB;AOhPQ;EACI,gBAAA;APkPZ;AOhPY;EACI,iBAAA;EACA,gCCtEU;EDuEV,eAAA;EACA,cNrCI;EMsCJ,iBAAA;EACA,iBAAA;EACA,gBAAA;APkPhB;AO/OY;EACI,gBAAA;EACA,iBAAA;EACA,gCCjFU;EDkFV,eAAA;EACA,cNhDI;EMiDJ,iBAAA;EACA,iBAAA;APiPhB;AO/OgB;EACI,+BCrFK;EDsFL,eAAA;EACA,cNnEE;EMoEF,iBAAA;EACA,iBAAA;EACA,eAAA;APiPpB;AO3OI;EACI,iCN9FS;EM+FT,gBAAA;EACA,gBAAA;EACA,kBAAA;AP6OR;AOzOA;EACI;IACI,eAAA;EP2ON;EOvOM;IACI,eAAA;EPyOV;EOtOM;IACI,cAAA;IACA,kBAAA;EPwOV;EOpOE;IACI,aAAA;EPsON;EOpOM;IACI,eAAA;IACA,iBAAA;IACA,iBAAA;IACA,cAAA;EPsOV;EOnOM;IACI,kBAAA;EPqOV;EOnOU;IACI,WAAA;IACA,mBAAA;EPqOd;EOnOc;IACI,gBAAA;EPqOlB;EOlOc;IACI,gBAAA;EPoOlB;EOhOU;IACI,aAAA;IACA,iBAAA;EPkOd;EOhOc;;IAEI,gBAAA;EPkOlB;EO7NM;IACI,iBAAA;IACA,mBAAA;EP+NV;EO3NE;IHnJA,eGoJkB;IHnJlB,iBGmJwB;IHlJxB,gBAH+C;IAI/C,iBAJqE;EJqXvE;EO7NE;IHvJA,eGwJkB;IHvJlB,iBGuJwB;IHtJxB,gBAH+C;IAI/C,iBAJqE;EJ2XvE;EO/NE;IACI,mBAAA;EPiON;AACF;AO9NA;EACI;IACI,YAAA;IACA,eAAA;EPgON;EO5NM;IACI,eAAA;IACA,YAAA;EP8NV;EOvNc;IACI,kBAAA;EPyNlB;EOtNc;IACI,kBAAA;EPwNlB;EOnNc;;IAEI,cAAA;EPqNlB;AACF;;AApaA;ECJA,mBAAA;EAkBA,sBAAA;EClBA;;;IAAA;EAKA;;IAAA;EAgBA;;IAAA;EAQA;;IAAA;EC7BA;;;IAAA;ECAA;;;IAAA;EAAA;;;IAAA;ECEA;;;IAAA;ECFA;;;IAAA;AN8cA;AKvcA;EACI,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;EACA,kCAAA;ALycJ;AKvcI;EAEI,sBAAA;ALwcR;AKrcI;EACI,wBAAA;ALucR;AKncA;;EAEI,SAAA;EACA,iBAAA;ALqcJ;AKlcA;EACI,WAAA;ALocJ;AKjcA;EACI,WAAA;ALmcJ;AKhcA;;;;;EAKI,SAAA;ALkcJ;AK/bA;;;;;;;;;;;;EAYI,oBAAA;ALicJ;AK9bA;EACI,OAAA;ALgcJ;AK9bI;EACI,WAAA;ALgcR;AK7bI;EAEI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AL8bR;AK1bA;EACI,WAAA;AL4bJ;AKzbA;EACI,YAAA;AL2bJ;AM3gBA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsEI,uBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;AN6gBJ;AM1gBA;;;;;;;;;;;;EAYI,cAAA;AN4gBJ;AMzgBA;;EAEI,gBAAA;AN2gBJ;AMxgBA;;EAEI,YAAA;AN0gBJ;AMxgBI;;;;EAEI,aAAA;AN4gBR;AMxgBA;EACI,uBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;AN0gBJ;AMvgBA;EACI,yBAAA;EACA,iBAAA;ANygBJ;AMtgBA;EACI,SAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;ANwgBJ;AMrgBA;;EAEI,sBAAA;ANugBJ;AMpgBA;EACI,kBAAA;ANsgBJ;AMlgBI;EACI,aAAA;ANogBR;AMhgBA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;ANkgBJ;AM7fQ;EACI,gBAAA;EACA,cAAA;AN+fZ;AM3fY;EACI,cAAA;AN6fhB;ASpqBA;EACI,mxCAAA;EACA,yBAAA;ATsqBJ;ASnqBA;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;ATqqBJ;ASlqBA;EACI,WAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EA4CA,qIACI;AT6nBR;ASrnBA;EACI,uBAAA;ATunBJ;ASpnBA;EACI;IACI,WAAA;IACA,aAAA;IA4CA,sIACI;ET+kBV;AACF;ASvkBA;EACI;IACI,WAAA;IACA,aAAA;ETykBN;AACF;AU3sBA;EACI,eAAA;EACA,cAAA;EACA,WAAA;AV6sBJ;AU1sBA;EACI,kEAAA;EACA,iBAAA;EACA,iBAAA;AV4sBJ;AUzsBA;EACI,gBTfY;ESgBZ,2CTfa;ESgBb,mBAAA;EACA,YAAA;AV2sBJ;AUzsBI;EACI,gBAAA;AV2sBR;AUxsBY;EACI,YAAA;EACA,aAAA;EACA,iBAAA;AV0sBhB;AUxsBY;EACI,YAAA;EACA,aAAA;EACA,iBAAA;AV0sBhB;AUtsBQ;EACI,gBAAA;AVwsBZ;AUtsBY;EACI,iBAAA;EACA,gCFzCU;EE0CV,eAAA;EACA,cTvCS;ESwCT,iBAAA;EACA,iBAAA;EACA,gBAAA;AVwsBhB;AUrsBY;EACI,gBAAA;EACA,iBAAA;EACA,gCFpDU;EEqDV,eAAA;EACA,cTlDS;ESmDT,iBAAA;EACA,iBAAA;AVusBhB;AUrsBgB;EACI,+BFxDK;EEyDL,eAAA;EACA,cTtDD;ESuDC,iBAAA;EACA,iBAAA;EACA,eAAA;AVusBpB;AUjsBI;EACI,sFTzCiB;ES0CjB,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AVmsBR;AUhsBI;EACI,iBAAA;EACA,kBAAA;AVksBR;AU7rBI;EACI,cTpFU;ESqFV,+BFpFiB;EJgBrB,eMsEkB;ENrElB,iBMqEwB;ENpExB,gBAH+C;EAI/C,iBAJqE;AJwwBzE;AU7rBA;EACI;IACI,eAAA;EV+rBN;EU5rBE;IACI,eAAA;EV8rBN;EU5rBM;IACI,kBAAA;EV8rBV;EU5rBU;IACI,WAAA;IACA,mBAAA;EV8rBd;EU5rBc;IACI,gBAAA;EV8rBlB;EU5rBc;IACI,gBAAA;EV8rBlB;EU1rBU;IACI,iBAAA;EV4rBd;EU1rBc;IACI,gBAAA;EV4rBlB;EUzrBc;IACI,gBAAA;EV2rBlB;EUtrBM;IACI,iBAAA;IACA,mBAAA;EVwrBV;EUrrBM;IACI,iBAAA;IACA,kBAAA;EVurBV;EUnrBE;IACI,yBAAA;IACA,2CAAA;EVqrBN;EUjrBM;IACI,oBAAA;INhIR,eMkIsB;INjItB,iBMiI4B;INhI5B,gBAH+C;IAI/C,iBAJqE;EJwzBvE;AACF;AUjrBA;EACI;IACI,YAAA;EVmrBN;EUhrBE;IACI,UAAA;IACA,aAAA;EVkrBN;EU9qBc;IACI,kBAAA;EVgrBlB;EU7qBc;IACI,kBAAA;EV+qBlB;EU3qBU;IACI,iBAAA;EV6qBd;EU3qBc;IACI,iBAAA;EV6qBlB;EU1qBc;IACI,iBAAA;EV4qBlB;AACF","sourcesContent":[":host(.aulani) {\r\n    @import './error-banner.component.aulani.scss';\r\n}\r\n\r\n:host(.wdw) {\r\n    @import './error-banner.component.wdw.scss';\r\n}\r\n","/* WDW COLOR CODE */\r\n\r\n$page-background: #E8EDF0;\r\n$primary-color: #FFF;\r\n$primary-shadow: 0 0 4px 0 rgba(37, 59, 86, 0.5);\r\n$secondary-color: #0470AB;\r\n$wdw-primary-message-text-color: #78899E;\r\n$wdw-primary-text-color: #253B56;\r\n$wdw-h3-heading: #424B5A;\r\n$primary-border: thin solid #D8D8D8;\r\n$primary-wdw-link: #1994D7;\r\n$secondary-wdw-link: #1B96D5;\r\n$wdw-message-span: #130026;\r\n$wdw-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$wdw-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$wdw-breadcrumbs-next-color: #73A4BF;\r\n$wdw-disabled-color: #BADFF3;\r\n\r\n/* AULANI COLOR CODE */\r\n$papaya-whitebg-color: #D04901;\r\n$papaya-greybg-color: #B73C00;\r\n$aulani-link-color: #B73C00;\r\n$primary-aulani-border: thin solid #918F8C;\r\n$aulani-border-color: #918F8C;\r\n$aulani-secondary-text-color: #867F77;\r\n$border-background: #FFF;\r\n$primary-aulani-link: #D04901;\r\n$secondary-aulani-link: #D24B00;\r\n$aulani-primary-text-color: #382613;\r\n$aulani-warm-grey-color: #69645E;\r\n$primary-info-text: #8294AA;\r\n$secondary-button-background: #F3EEE6;\r\n$radio-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 15%, #DBDBDB 89%, #FBFBFB 100%);\r\n$footer-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 14%, #DBDBDB 95%, #FBFBFB 100%);\r\n$aulani-hover-link: #B14308;\r\n$aulani-border: radial-gradient($aulani-border-color 0%, #FFF 100%);\r\n$aulani-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$aulani-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$aulani-error-text: #5C4830;\r\n$error-label-color: #FF4605;\r\n$aulani-text-disabed-color: #EFB698;\r\n\r\n$default-button-border: #0079BC;\r\n$default-text-color: #00233C;\r\n$hover-button-border: #006096;\r\n$active-button-border: #083C5D;\r\n$disabled-button-border: #B7E4F7;\r\n","/**\r\n * variables.scss\r\n * Contains the sitewide variables\r\n */\r\n\r\n/**\r\n * Breakpoints variables\r\n */\r\n\r\n$breakpoints: (\r\n    x-small: 0,\r\n    mobile: 320px,\r\n    tablet: 768px,\r\n    desktop: 1024px\r\n);\r\n\r\n$orientations: (\r\n    portrait: portrait,\r\n    landscape: landscape\r\n);\r\n\r\n/**\r\n * Colors variables\r\n */\r\n\r\n$colors: (\r\n    'transparent': transparent,\r\n);\r\n\r\n/**\r\n * z-index variables\r\n */\r\n\r\n$zindex: (\r\n    'base': 1,\r\n    'menu': 2,\r\n    'overlay': 3,\r\n    'modal': 4,\r\n    'toast': 5\r\n);\r\n","/**\r\n * function.scss\r\n * Contains the sitewide functions\r\n */\r\n\r\n@function colors($color) {\r\n    @if not map-has-key($colors, $color) {\r\n        @warn 'No color found for `#{$color}`.';\r\n    }\r\n    \r\n    @return map-get($colors, $color);\r\n}\r\n\r\n@function zindex($layer) {\r\n    @if not map-has-key($zindex, $layer) {\r\n        @warn 'No z-index found for `#{$layer}`.';\r\n    }\r\n    \r\n    @return map-get($zindex, $layer);\r\n}\r\n","/**\r\n * mixins.scss\r\n * Contains the sitewide mixins\r\n */\r\n\r\n@mixin from-breakpoint($bp) {\r\n    @if ($bp == 'x-small') {\r\n        @content;\r\n    }\r\n    @else {\r\n        @if map-has-key($breakpoints, $bp) {\r\n            $list: map-get($breakpoints, $bp);\r\n            $bp: nth($list, 1);\r\n        }\r\n        \r\n        @media screen and (min-width: #{$bp}) {\r\n            @content;\r\n        }\r\n    }\r\n}\r\n\r\n@mixin font($font-size, $line-height, $font-weight:400, $letter-spacing: 0) {\r\n    font-size: $font-size;\r\n    line-height: $line-height;\r\n    font-weight: $font-weight;\r\n    letter-spacing: $letter-spacing;\r\n}\r\n\r\n@mixin host-block() {\r\n    :host {\r\n        display: block;\r\n    }\r\n}\r\n\r\n@mixin float-left() {\r\n    float: left;\r\n}\r\n\r\n@mixin float-right() {\r\n    float: right;\r\n}\r\n\r\n@mixin btn-link($btnColor: #B73C00, $hoverColor: #7C3813) {\r\n    color: $btnColor;\r\n    font-weight: 600;\r\n\r\n    &:hover {\r\n        color: $hoverColor;\r\n    }\r\n\r\n    &:focus {\r\n        color: $btnColor;\r\n        outline: 2px solid $btnColor;\r\n        outline-offset: 4px;\r\n    }\r\n}\r\n","@import '../abstracts/mixins';\r\n\r\n/**\r\n * global.scss\r\n * Contains the sitewide global styles\r\n */\r\n\r\n* {\r\n    background-repeat: no-repeat;\r\n    box-sizing: border-box;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    -webkit-font-smoothing: antialiased;\r\n    position: relative;\r\n    text-rendering: optimizeLegibility;\r\n\r\n    &:before,\r\n    &:after {\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    &:focus {\r\n        outline: 1px dotted #000;\r\n    }\r\n}\r\n\r\nhtml,\r\nbody {\r\n    margin: 0;\r\n    min-height: 100vh;\r\n}\r\n\r\nbody {\r\n    width: 100%;\r\n}\r\n\r\nimg {\r\n    width: 100%;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5 {\r\n    margin: 0;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\nspan,\r\na,\r\nli,\r\np,\r\ninput,\r\ntextarea {\r\n    font-family: inherit;\r\n}\r\n\r\n.clearfix {\r\n    zoom: 1;\r\n\r\n    &:after {\r\n        clear: both;\r\n    }\r\n    \r\n    &:after,\r\n    &:before {\r\n        content: '\\0020';\r\n        display: block;\r\n        overflow: hidden;\r\n        visibility: hidden;\r\n        width: 0;\r\n        height: 0;\r\n    }\r\n}\r\n\r\n.float-left {\r\n    float: left;\r\n}\r\n\r\n.float-right {\r\n    float: right;\r\n}\r\n","/**\r\n * reset.scss\r\n * Contains the sitewide css reset\r\n */\r\n\r\nhtml,\r\nbody,\r\ndiv,\r\nspan,\r\nobject,\r\niframe,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\np,\r\nblockquote,\r\npre,\r\nabbr,\r\naddress,\r\naddress,\r\ncite,\r\ncode,\r\ndel,\r\ndfn,\r\nem,\r\nimg,\r\nins,\r\nkbd,\r\nq,\r\nsamp,\r\nsmall,\r\nstrong,\r\nsub,\r\nsup,\r\nvar,\r\nb,\r\ni,\r\ndl,\r\ndt,\r\ndd,\r\nol,\r\nul,\r\nli,\r\nfieldset,\r\nform,\r\nlabel,\r\nlegend,\r\ntable,\r\ncaption,\r\ntbody,\r\ntfoot,\r\nthead,\r\ntr,\r\nth,\r\ntd,\r\narticle,\r\naside,\r\ncanvas,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nmenu,\r\nnav,\r\nsection,\r\nsummary,\r\ntime,\r\nmark,\r\naudio,\r\nvideo {\r\n    background: colors('transparent');\r\n    border: 0;\r\n    font-size: 100%;\r\n    margin: 0;\r\n    outline: 0;\r\n    padding: 0;\r\n    vertical-align: baseline;\r\n}\r\n\r\narticle,\r\naside,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nimg,\r\nmenu,\r\nnav,\r\nsection {\r\n    display: block;\r\n}\r\n\r\nol,\r\nul {\r\n    list-style: none;\r\n}\r\n\r\nblockquote,\r\nq {\r\n    quotes: none;\r\n\r\n    :before,\r\n    :after {\r\n        content: none;\r\n    }\r\n}\r\n\r\na {\r\n    background: colors('transparent');\r\n    font-size: 100%;\r\n    margin: 0;\r\n    padding: 0;\r\n    text-decoration: none;\r\n    touch-action: manipulation;\r\n    vertical-align: baseline;\r\n}\r\n\r\ntable {\r\n    border-collapse: collapse;\r\n    border-spacing: 0;\r\n}\r\n\r\nhr {\r\n    border: 0;\r\n    display: block;\r\n    height: 1px;\r\n    margin: 1em 0;\r\n    padding: 0;\r\n}\r\n\r\ninput,\r\nselect {\r\n    vertical-align: middle;\r\n}\r\n\r\naddress {\r\n    font-style: normal;\r\n}\r\n\r\ninput {\r\n    &::-ms-clear {\r\n        display: none;\r\n    }\r\n}\r\n\r\nbutton {\r\n    background: none;\r\n    border: 0;\r\n    padding: 0;\r\n}\r\n\r\n.aulani {\r\n    .room-ready-terms-and-conditions {\r\n        p a {\r\n            font-weight: 600;\r\n            color: #D04901;\r\n        }\r\n\r\n        &.edit {\r\n            p a {\r\n                color: #B73C00;\r\n            }\r\n        }\r\n    }\r\n}\r\n","@import '../../assets/style/theme/index';\r\n@import '../../assets/style/base';\r\n@import '../../assets/style/base/font.scss';\r\n\r\n.olci-container {\r\n    padding: 0;\r\n    margin: 0 auto;\r\n    width: 100%;\r\n}\r\n\r\n.page-layout {\r\n    background: $primary-color;\r\n    min-height: 100vh;\r\n    padding: 0 0 20px;\r\n}\r\n\r\n.aulani-logo {\r\n    padding-top: 32px;\r\n    padding-bottom: 9px;\r\n    border-bottom: $primary-aulani-border;\r\n\r\n    .logo-wrap {\r\n        width: 100%;\r\n        margin: 0 auto;\r\n    }\r\n\r\n    .logo-img {\r\n        width: 149px;\r\n        height: 50px;\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n.error-header {\r\n    font-family: Goudy-Regular;\r\n    color: $aulani-primary-text-color;\r\n\r\n    @include font(32px, 40px);\r\n}\r\n\r\n.page-content {\r\n    height: 661px;\r\n\r\n    .aulani-header {\r\n        font-family: Goudy-Regular;\r\n        color: $aulani-primary-text-color;\r\n        margin-top: 35px;\r\n        margin-left: 20px;\r\n\r\n        @include font(32px, 40px);\r\n    }\r\n\r\n    .error-page {\r\n        padding-top: 6px;\r\n\r\n        .image-goofy {\r\n            .goofy-img {\r\n                width: 221px;\r\n                height: 251px;\r\n                margin-left: 37px;\r\n            }\r\n            .checkin-bell-img {\r\n                width: 255px;\r\n                height: 240px;\r\n                margin-left: 37px;\r\n            }\r\n        }\r\n\r\n        .error-info {\r\n            margin-top: 29px;\r\n\r\n            .sorry-text {\r\n                margin-left: 21px;\r\n                font-family: $inspiretwdc-medium-font;\r\n                font-size: 40px;\r\n                color: $aulani-error-text;\r\n                letter-spacing: 0;\r\n                line-height: 40px;\r\n                font-weight: 400;\r\n            }\r\n\r\n            .error-text {\r\n                margin-top: 22px;\r\n                margin-left: 20px;\r\n                font-family: $inspiretwdc-medium-font;\r\n                font-size: 14px;\r\n                color: $aulani-error-text;\r\n                letter-spacing: 0;\r\n                line-height: 21px;\r\n\r\n                .try-again-link {\r\n                    font-family: $inspiretwdc-roman-font;\r\n                    font-size: 14px;\r\n                    color: $primary-aulani-link;\r\n                    letter-spacing: 0;\r\n                    line-height: 24px;\r\n                    cursor: pointer;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .horizontal-line {\r\n        border-bottom: $primary-border;\r\n        margin-top: 44px;\r\n        margin-left: 8px;\r\n        margin-right: 22px;\r\n    }\r\n}\r\n\r\n@media (min-width: 767px) {\r\n    .olci-container {\r\n        padding: 0 40px;\r\n    }\r\n\r\n    .aulani-logo {\r\n        .logo-wrap {\r\n            padding: 0 40px;\r\n        }\r\n\r\n        .logo-img {\r\n            margin-left: 0;\r\n            margin-right: auto;\r\n        }\r\n    }\r\n\r\n    .page-content {\r\n        height: 760px;\r\n\r\n        .aulani-header {\r\n            font-size: 40px;\r\n            letter-spacing: 0;\r\n            line-height: 50px;\r\n            margin-left: 0;\r\n        }\r\n\r\n        .error-page {\r\n            padding-top: 143px;\r\n\r\n            .image-goofy {\r\n                float: left;\r\n                padding-right: 53px;\r\n\r\n                .goofy-img {\r\n                    margin-left: 40%;\r\n                }\r\n\r\n                .checkin-bell-img {\r\n                    margin-left: 40%;\r\n                }\r\n            }\r\n\r\n            .error-info {\r\n                margin-top: 0;\r\n                padding-top: 40px;\r\n\r\n                .sorry-text,\r\n                .error-text {\r\n                    margin-left: 50%;\r\n                }\r\n            }\r\n        }\r\n\r\n        .horizontal-line {\r\n            margin-top: 270px;\r\n            margin-bottom: 18px;\r\n        }\r\n    }\r\n\r\n    .aulani-header {\r\n        @include font(32px, 40px);\r\n    }\r\n\r\n    .error-header {\r\n        @include font(40px, 50px);\r\n    }\r\n\r\n    .horizontal-line {\r\n        margin-bottom: 30px;\r\n    }\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n    .olci-container {\r\n        width: 970px;\r\n        padding: 0 15px;\r\n    }\r\n\r\n    .aulani-logo {\r\n        .logo-wrap {\r\n            padding: 0 15px;\r\n            width: 970px;\r\n        }\r\n    }\r\n\r\n    .page-content {\r\n        .error-page {\r\n            .image-goofy {\r\n                .goofy-img {\r\n                    margin-left: 199px;\r\n                }\r\n\r\n                .checkin-bell-img {\r\n                    margin-left: 199px;\r\n                }\r\n            }\r\n\r\n            .error-info {\r\n                .sorry-text,\r\n                .error-text {\r\n                    margin-left: 0;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n","$inspiretwdc-font: 'InspireTWDC';\r\n$inspiretwdc-book-font: 'InspireTWDCBook';\r\n$inspiretwdc-light-font: 'InspireTWDCLight';\r\n$inspiretwdc-medium-font: 'InspireTWDCMedium';\r\n$inspiretwdc-heavy-font: 'InspireTWDCHeavy';\r\n$inspiretwdc-black-font: 'InspireTWDCBlack';\r\n$inspiretwdc-roman-font: 'InspireTWDCRoman';\r\n",".pepde {\r\n    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAKuCAYAAABgwHabAAADZ0lEQVRIS83QZ08UURQG4NzfgaggKggSu9iCsaJYI2qkGLE3BIOKJbFEFBGjRkOv0kHq0kGaAtIEgkgHe++/YHzvYcc7M9ldAfnAlyenz91lxYO/JUYUDfxSUtj/U2J5/T+U6PhILm/o+kBOH7pEFiezF7WMHkSC9J7vEiPSur8h6sZIaifSlC4VybxGJL3AXMJf4ju+SoyI60BDQ/RzNIio9i8cjBAR7agJwto+SyysDTVlhDSkFWvBLegGtyC93ypzrwUNwd1nSO80Y05wu+mTxIhbzSCo6aNMI+aCODcb0AhsBDca0A2sV0E1IqD+g8Su12OOCKDoKRrENY5/HUb869DQQym4Wovulbp/crkWwxou8QPExRpTXKh5LzHi/JN3SpQ1HDj3GCPE2WrM+Q2BBnGmCg2/SkCRIU5Xo3GqCmuEb+VbZXqSp4RvBeYIURORT8UbiflU4ABxogIb3pWIvMt5VC7XvB4hVVCGNS/O8SEwp0euHSvFxuFSpEfK5IjSoyUyh0pe60coIg4a40DxK4npwYH9RRjWsK9YVdtbhA3Cs/ClMqLUswDDGvbkY3h3ARARpR6FnHyseeRjzZ3vuhcgdcsfVIM5N36FcM2jETmilNilw5qrDo2dOqSCHblomGY733XJHZDYtmxEhEsOrmzNQWSULdnYMMTmLKwZYhNvGGJjJk4RGzL69ThnItKDNedMzkMakdP1GUg1OPHaunSZtXzDKQ2nKBKsSUdtGKxO65PYqnROGg6sTMUaRSKlmoYVKdigGkXE8lQVjim9EjMM1hxTjLCMn9KShFNUW5qMyChLknokpiURa4uTVCxKxBWjLORfE12HBBx1SMABwQJ1Oj8eG4aY9wC7RrvUoBGjzOHduXyOoqE0To5mx3VLbJTMiu2SmCHseUMJvmYfS2galMrdmTF4yxhiG4PzhF20AF+ziwa2JpkRhbeMEptIfM001lEYUYIHWUcRoiFqcmQTiWh6JJ6mpJOnhKahSqfyLmF6jrpiWERWEXgaMU2NaIxoRLM2JRyXCUt+nrCKwFtEY0SRuGIRjj+HGO4ByzB8l7AIHwsmh+HHjDUT+VEN4huTQvF7/wdzfkAP/gPzUELUTEdGh+VTE0Lw+vGJWTB+2zh5Gr3FLBj/mhKqGWpo5oaV/gGNQYq8UD/CuwAAAABJRU5ErkJggg==) top center repeat-x;\r\n    background-color: #1D96D7;\r\n}\r\n\r\n#backgroundGlowContainer {\r\n    width: 100%;\r\n    position: relative;\r\n    margin: auto;\r\n    max-width: 940px;\r\n}\r\n\r\n#backgroundGlow {\r\n    width: 100%;\r\n    height: 800px;\r\n    position: absolute;\r\n    top: -380px;\r\n    z-index: -1;\r\n    background:\r\n        -moz-radial-gradient(\r\n            center,\r\n            ellipse cover,\r\n            rgba(255, 255, 255, 0.95) 0%,\r\n            rgba(255, 255, 255, 0.5) 50%,\r\n            rgba(71, 218, 255, 0) 70%\r\n        );\r\n    background:\r\n        -webkit-gradient(\r\n            radial,\r\n            center center,\r\n            0,\r\n            center center,\r\n            100%,\r\n            color-stop(0%, rgba(255, 255, 255, 0.95)),\r\n            color-stop(50%, rgba(255, 255, 255, 0.5)),\r\n            color-stop(70%, rgba(71, 218, 255, 0))\r\n        );\r\n    background:\r\n        -webkit-radial-gradient(\r\n            center,\r\n            ellipse cover,\r\n            rgba(255, 255, 255, 0.95) 0%,\r\n            rgba(255, 255, 255, 0.5) 50%,\r\n            rgba(71, 218, 255, 0) 70%\r\n        );\r\n    background:\r\n        -o-radial-gradient(\r\n            center,\r\n            ellipse cover,\r\n            rgba(255, 255, 255, 0.95) 0%,\r\n            rgba(255, 255, 255, 0.5) 50%,\r\n            rgba(71, 218, 255, 0) 70%\r\n        );\r\n    background:\r\n        -ms-radial-gradient(\r\n            center,\r\n            ellipse cover,\r\n            rgba(255, 255, 255, 0.95) 0%,\r\n            rgba(255, 255, 255, 0.5) 50%,\r\n            rgba(71, 218, 255, 0) 70%\r\n        );\r\n    background:\r\n        radial-gradient(\r\n            ellipse at center,\r\n            rgba(255, 255, 255, 0.95) 0%,\r\n            rgba(255, 255, 255, 0.5) 50%,\r\n            rgba(71, 218, 255, 0) 70%\r\n        );\r\n}\r\n\r\n#pageContainer {\r\n    background: transparent;\r\n}\r\n\r\n@media all and (max-width: 767px) {\r\n    #backgroundGlow {\r\n        top: -340px;\r\n        height: 600px;\r\n        background:\r\n            -moz-radial-gradient(\r\n                center,\r\n                ellipse cover,\r\n                rgba(255, 255, 255, 0.95) 0%,\r\n                rgba(255, 255, 255, 0.4) 40%,\r\n                rgba(255, 218, 255, 0) 70%\r\n            );\r\n        background:\r\n            -webkit-gradient(\r\n                radial,\r\n                center center,\r\n                0,\r\n                center center,\r\n                100%,\r\n                color-stop(0%, rgba(255, 255, 255, 0.95)),\r\n                color-stop(40%, rgba(255, 255, 255, 0.4)),\r\n                color-stop(70%, rgba(255, 218, 255, 0))\r\n            );\r\n        background:\r\n            -webkit-radial-gradient(\r\n                center,\r\n                ellipse cover,\r\n                rgba(255, 255, 255, 0.95) 0%,\r\n                rgba(255, 255, 255, 0.4) 40%,\r\n                rgba(255, 218, 255, 0) 70%\r\n            );\r\n        background:\r\n            -o-radial-gradient(\r\n                center,\r\n                ellipse cover,\r\n                rgba(255, 255, 255, 0.95) 0%,\r\n                rgba(255, 255, 255, 0.4) 40%,\r\n                rgba(255, 218, 255, 0) 70%\r\n            );\r\n        background:\r\n            -ms-radial-gradient(\r\n                center,\r\n                ellipse cover,\r\n                rgba(255, 255, 255, 0.95) 0%,\r\n                rgba(255, 255, 255, 0.4) 40%,\r\n                rgba(255, 218, 255, 0) 70%\r\n            );\r\n        background:\r\n            radial-gradient(\r\n                ellipse at center,\r\n                rgba(255, 255, 255, 0.95) 0%,\r\n                rgba(255, 255, 255, 0.4) 40%,\r\n                rgba(255, 218, 255, 0) 70%\r\n            );\r\n    }\r\n}\r\n\r\n@media all and (max-width: 568px) {\r\n    #backgroundGlow {\r\n        top: -180px;\r\n        height: 300px;\r\n    }\r\n}\r\n","@import '../../assets/style/theme/index';\r\n@import '../../assets/style/base';\r\n@import '../../assets/style/theme/background.scss';\r\n@import '../../assets/style/base/font.scss';\r\n\r\n.olci-container {\r\n    padding: 0 10px;\r\n    margin: 0 auto;\r\n    width: 100%;\r\n}\r\n\r\n.page-layout {\r\n    background: url('../../assets/images/wdw-bg.png') top center repeat-x;\r\n    min-height: 100vh;\r\n    padding: 0 0 20px;\r\n}\r\n\r\n.page-content {\r\n    background: $primary-color;\r\n    box-shadow: $primary-shadow;\r\n    border-radius: 12px;\r\n    height: 100%;\r\n\r\n    .error-page {\r\n        padding-top: 6px;\r\n\r\n        .image-goofy {\r\n            .goofy-img {\r\n                width: 221px;\r\n                height: 251px;\r\n                margin-left: 37px;\r\n            }\r\n            .checkin-bell-img {\r\n                width: 255px;\r\n                height: 240px;\r\n                margin-left: 37px;\r\n            }\r\n        }\r\n\r\n        .error-info {\r\n            margin-top: 29px;\r\n\r\n            .sorry-text {\r\n                margin-left: 21px;\r\n                font-family: $inspiretwdc-medium-font;\r\n                font-size: 40px;\r\n                color: $wdw-primary-text-color;\r\n                letter-spacing: 0;\r\n                line-height: 40px;\r\n                font-weight: 400;\r\n            }\r\n\r\n            .error-text {\r\n                margin-top: 22px;\r\n                margin-left: 20px;\r\n                font-family: $inspiretwdc-medium-font;\r\n                font-size: 14px;\r\n                color: $wdw-primary-text-color;\r\n                letter-spacing: 0;\r\n                line-height: 21px;\r\n\r\n                .try-again-link {\r\n                    font-family: $inspiretwdc-roman-font;\r\n                    font-size: 14px;\r\n                    color: $primary-wdw-link;\r\n                    letter-spacing: 0;\r\n                    line-height: 24px;\r\n                    cursor: pointer;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .horizontal-line {\r\n        background: $footer-gradient-border;\r\n        height: 1px;\r\n        margin-top: 44px;\r\n        margin-left: 8px;\r\n        margin-right: 22px;\r\n    }\r\n\r\n    .footer-section {\r\n        margin-left: 20px;\r\n        margin-right: 20px;\r\n    }\r\n}\r\n\r\n.error-header {\r\n    h1 {\r\n        color: $secondary-color;\r\n        font-family: $inspiretwdc-roman-font;\r\n\r\n        @include font(24px, 48px);\r\n    }\r\n}\r\n\r\n@media only screen and (min-width: 767px) {\r\n    .olci-container {\r\n        padding: 0 15px;\r\n    }\r\n\r\n    .page-content {\r\n        padding: 40px 0;\r\n\r\n        .error-page {\r\n            padding-top: 143px;\r\n\r\n            .image-goofy {\r\n                float: left;\r\n                padding-right: 53px;\r\n\r\n                .goofy-img {\r\n                    margin-left: 50%;\r\n                }\r\n                .checkin-bell-img {\r\n                    margin-left: 50%;\r\n                }\r\n            }\r\n\r\n            .error-info {\r\n                padding-top: 40px;\r\n\r\n                .error-text {\r\n                    margin-left: 50%;\r\n                }\r\n\r\n                .sorry-text {\r\n                    margin-left: 50%;\r\n                }\r\n            }\r\n        }\r\n\r\n        .horizontal-line {\r\n            margin-top: 270px;\r\n            margin-bottom: 30px;\r\n        }\r\n\r\n        .footer-section {\r\n            margin-left: 40px;\r\n            margin-right: 40px;\r\n        }\r\n    }\r\n\r\n    .page-section {\r\n        padding: 0 41px 30px 43px;\r\n        border-bottom: 1px solid $primary-border;\r\n    }\r\n\r\n    .error-header {\r\n        h1 {\r\n            padding: 29px 0 18px;\r\n\r\n            @include font(36px, 40px);\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n    .olci-container {\r\n        width: 970px;\r\n    }\r\n\r\n    .page-content {\r\n        padding: 0;\r\n        height: 760px;\r\n\r\n        .error-page {\r\n            .image-goofy {\r\n                .goofy-img {\r\n                    margin-left: 199px;\r\n                }\r\n\r\n                .checkin-bell-img {\r\n                    margin-left: 199px;\r\n                }\r\n            }\r\n\r\n            .error-info {\r\n                padding-top: 40px;\r\n\r\n                .error-text {\r\n                    margin-left: 52px;\r\n                }\r\n\r\n                .sorry-text {\r\n                    margin-left: 21px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
